<template>
  <div class="check-mark">
    <check-icon/>
  </div>
</template>

<script>
import CheckIcon from "../icons/CheckIcon.vue";

export default {
  name: "CheckMark",
  components: {CheckIcon},
}
</script>
